import { PredefinedPaymentMethod } from 'gen/ApiClient';

export const translatePaymentMethodOrDefault = (method: string, record: Record<PredefinedPaymentMethod, string>): string => {
	const e = record[method as PredefinedPaymentMethod];
	return e === undefined ? method : e;
};
